import { __decorate, __metadata, __param } from "tslib";
import { Inject, Injectable } from 'angular-ts-decorators';
var PfmUrlHelperService = (function () {
    function PfmUrlHelperService($location) {
        this.$location = $location;
    }
    Object.defineProperty(PfmUrlHelperService.prototype, "filters", {
        get: function () {
            return (this.$location.search().pff || '').split('-').filter(function (f) { return f !== ''; });
        },
        set: function (filters) {
            this.$location.search('pff', Array.isArray(filters) && filters.length > 0 ? filters.join('-') : null);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PfmUrlHelperService.prototype, "pageNumber", {
        get: function () {
            var locationPageNumber = Number(this.$location.search().pfp);
            if (isNaN(locationPageNumber)) {
                locationPageNumber = 1;
            }
            return locationPageNumber;
        },
        set: function (pageNumber) {
            this.$location.search('pfp', pageNumber || null);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PfmUrlHelperService.prototype, "searchQuery", {
        get: function () {
            return this.$location.search().pfq || '';
        },
        set: function (searchQuery) {
            this.$location.search('pfq', searchQuery || null);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PfmUrlHelperService.prototype, "sorter", {
        get: function () {
            return this.$location.search().pfs || '';
        },
        set: function (sorter) {
            this.$location.search('pfs', sorter || null);
        },
        enumerable: false,
        configurable: true
    });
    PfmUrlHelperService.$inject = ['$location'];
    PfmUrlHelperService = __decorate([
        Injectable('pfmUrlHelper'),
        __param(0, Inject('$location')),
        __metadata("design:paramtypes", [Object])
    ], PfmUrlHelperService);
    return PfmUrlHelperService;
}());
export { PfmUrlHelperService };
